module.exports = __webpack_public_path__ + "static/media/Picker_niveau2_elN0_3_997716689.c1f9f570.png";